// PROFILE CARD CAROUSEL — pure scope-selection logic (no React, no I/O), kept
// separate so it's directly unit-testable. `scopes` is the array returned by
// GET /sessions/{id}/profiles: each eligible Profile card the session
// currently has sufficient accumulated evidence for, in canonical order.

export const SCOPE_ORDER = ["FILM", "SERIES", "GAMES", "SCREEN", "CROSS-MEDIA"];

// Which card should be selected right now, given the eligible set and
// whatever the user (or the app) previously had selected.
//
//  * A still-eligible manual/previous selection always wins — this is what
//    makes "leave Profile, come back" preserve the user's chosen card, and
//    what stops a newly-completed Test from hijacking a card the user is
//    actively looking at.
//  * Otherwise fall back to `preferredScope` (the server's `defaultScope` —
//    the most recently played eligible single-domain scope) if it's present.
//  * Otherwise the first eligible scope in canonical order.
export function resolveSelectedScope(scopes, currentSelection, preferredScope) {
  if (!scopes || scopes.length === 0) return null;
  const keys = scopes.map((s) => s.scope);
  if (currentSelection && keys.includes(currentSelection)) return currentSelection;
  if (preferredScope && keys.includes(preferredScope)) return preferredScope;
  return keys[0];
}

export function findScopeProfile(scopes, scopeKey) {
  return (scopes || []).find((s) => s.scope === scopeKey) || null;
}

export function scopeIndex(scopes, scopeKey) {
  return (scopes || []).findIndex((s) => s.scope === scopeKey);
}

export function adjacentScope(scopes, currentSelection, direction) {
  if (!scopes || scopes.length === 0) return currentSelection;
  const i = scopeIndex(scopes, currentSelection);
  if (i === -1) return scopes[0].scope;
  const next = (i + direction + scopes.length) % scopes.length;
  return scopes[next].scope;
}
